/**
 * 数据权限指令
 * 根据数据创建人与当前登录用户是否一致控制元素显示
 * 使用: v-dataAuth="data.creatorId"
 */
export default {
    mounted(el: HTMLElement, binding: any) {
        if (!el) return;
        const { value } = binding;
        const { userState } = useStore('user');

        if (!value) {
            el.style.display = 'none';
        } else if (value && userState.value.userId !== value) {
            el.remove();
        } else {
            el.style.display = 'block';
        }
    },
    updated(el: HTMLElement, binding: any) {
        if (!el) return;
        const { value } = binding;
        const { userState } = useStore('user');
        if (!value) {
            el.style.display = 'none';
        } else if (value && userState.value.userId !== value) {
            el.remove();
        } else {
            el.style.display = 'block';
        }
    },
};
